/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Check_RetryInputs */

const cs_portals_check_retry = /** @type {(inputs: Portals_Check_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zkontrolovat znovu`)
};

const en_portals_check_retry = /** @type {(inputs: Portals_Check_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check again`)
};

/**
* | output |
* | --- |
* | "Check again" |
*
* @param {Portals_Check_RetryInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_check_retry = /** @type {((inputs?: Portals_Check_RetryInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Check_RetryInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_check_retry(inputs)
	return cs_portals_check_retry(inputs)
});